import { GeolocationServices } from '@constants';
import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import Config from '../types/Config';
import TgLabSb from '../types/TgLabSb';
import UserStatus from '../types/UserStatus';
import GeoComplyState from '../types/state/GeoComplyState';
import config from './reducers/config';
import modals, { ModalsState } from './reducers/modals';
import translations, { Symbols } from './reducers/translations';
import user from './reducers/user';

const isGeoComplyEnabled =
  window.__config__.componentSettings?.geolocationSettings?.service ===
    GeolocationServices.GeoComply && !!window.__config__.geoComplyKey;
const v2AuthEnabled = !!window.__config__.componentSettings?.v2Auth;
const tgLabSbEnabled = !!window.__config__.tgLabSb;

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: () => {
    return null;
  },
  stateTransformer: (state: RootState) => {
    const geoComply =
      isGeoComplyEnabled && state.geoComply
        ? {
            ...state.geoComply,
            license: !!state.geoComply.license,
            geoLocation: !!state.geoComply.geoLocation,
            savedState: !!state.geoComply.savedState,
          }
        : null;
    const transformedState = {
      ...state,
      config: null,
      translations: null,
      user: null,
      geoComply,
    };
    return transformedState;
  },
});

const createStoreAsync = async () => {
  const asyncReduxMiddleware = [
    // v2AuthEnabled && import('./middleware/userWebsocket'),
    // isGeoComplyEnabled && import('./middleware/geoComply'),
  ].filter(Boolean) as Promise<any>[];
  let reducers: any = {
    modals,
    user,
    config,
    translations,
  };
  // if (isGeoComplyEnabled) {
  //   await import('./reducers/geoComply').then(geoComply => {
  //     reducers = {
  //       ...reducers,
  //       geoComply: geoComply.default,
  //     };
  //   });
  // }
  if (tgLabSbEnabled) {
    await import('./reducers/tgLabSb').then(tgLabSb => {
      reducers = {
        ...reducers,
        tgLabSb: tgLabSb.default,
      };
    });
  }
  const reduxMiddleware = await Promise.all(asyncReduxMiddleware)
    .then(modules => modules.map(module => module.default))
    .catch(() => []);
  return configureStore({
    reducer: reducers,
    middleware: defaultMiddleware =>
      defaultMiddleware().concat(reduxMiddleware),
    enhancers: [sentryReduxEnhancer],
    devTools: {
      trace: true,
    },
  });
};
export type RootState = {
  geoComply?: GeoComplyState;
  modals: ModalsState;
  user: UserStatus;
  tgLabSb: TgLabSb;
  config: Config;
  translations: Symbols | null;
};
export default createStoreAsync;
